<template>
    <b-card>
      <div slot="header">
        <b-row>
          <b-col md="6" v-if="field.constraints.table.search">
            <b-input-group>
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                :placeholder="`${this.$t('search')}`"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">{{ $t('clear') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col md="12">
            <div class="card-header-actions">
              <b-link class="card-header-action btn-setting" @click="createModal.show = true">
                <i class="icon-plus"></i>
              </b-link>
            </div>
          </b-col>
        </b-row>
      </div>
        <b-table striped hover :items="items" :filter="filter" :fields="fields" :perPage="field.constraints.table.per_page" :current-page="currentPage" ref="table">
          <template v-slot:[fieldCell(field)]="data" v-for="field in field.constraints.table.fields">
            <IdentityFields :field="field" :value="data.value" :key="field.key" :disabled="true" :labelCols="0" />
          </template>

          <template v-slot:cell(actions)="row" size="sm">
            <b-button size="sm" variant="danger" class="mr-1" @click="remove(row)">
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
        <nav>
          <b-pagination :total-rows="items.length" :per-page="field.constraints.table.per_page" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
        <main-dialog size="lg" v-model="createModal.show" title="Create" hide-footer>
          <Create :fields="fields" @onSave="(item) => addItem(item, false)" @onSaveAndContinue="(item) => addItem(item, true)" :translator="translator"/>
        </main-dialog>
    </b-card>
</template>

<style>
td.custom-table-actions {
  width: 20px !important;
}
</style>

<script>
import Create from './Create'
import _ from 'lodash'
import Vue from 'vue'


export default {
    name: "IdentityField_Table_Custom",
    components: {
      Create,
      IdentityFields: () => import('../../../IdentityFields.vue')
    },
    props: {
        value: {
          type: Array,
          default: () => {
            return [];
          }
        },
        field: {
          type: Object
        },

        translator: {
          type: Function
        }
    },
    data() {
      return {
        filter: null,

        createModal: {
            show: false,
            data: null
        },

        currentPage: 1
      }
    },

    methods: {
      addItem(item, show) {
        let items = this.items
        items.push(item)

        this.createModal.show = show;

        this.$emit('input', items)
        
        // refresh to make sure all new items are displayed
        this.$refs.table.refresh();
      },

      remove(item) {
        this.$mainDialog.msgBoxConfirm(this.translator('areYouSure')).then(resp => {
            if (resp) {
              this.items = this.items.filter((e, i) => {
                return i != item.index;
              })
            }
        })
        
      },

      fieldCell(field) {
        return `cell(${field.key})`;
      }
    },

    computed: {
      items: {
        get() {
          if (this.value == "") this.value = [];

          return this.value || [];
        },

        set(val) {
          this.$emit('input', val);
        }
      },

      fields() {
        let f = _.cloneDeep(this.field.constraints.table.fields);

        f.map(field => {
          field.sortable = true;
        })

        f.push({
          key: 'actions',
          label: '',
          thStyle: {
            'max-width': '20px'
          },
          tdClass: 'custom-table-actions'
        })


        return f;
      },
    }
}
</script>